import { render } from "./Reactions.vue?vue&type=template&id=4f091a9c&scoped=true"
import script from "./Reactions.vue?vue&type=script&lang=js"
export * from "./Reactions.vue?vue&type=script&lang=js"

import "./Reactions.vue?vue&type=style&index=0&id=4f091a9c&scoped=true&lang=scss"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f091a9c"]])

export default __exports__